import { render, staticRenderFns } from "./OrdersDstToSettlePopup.vue?vue&type=template&id=b6f5c438&scoped=true&"
import script from "./OrdersDstToSettlePopup.vue?vue&type=script&lang=js&"
export * from "./OrdersDstToSettlePopup.vue?vue&type=script&lang=js&"
import style0 from "./OrdersDstToSettlePopup.vue?vue&type=style&index=0&id=b6f5c438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f5c438",
  null
  
)

export default component.exports